// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"466":"99b045d7","497":"b3a3eca3","851":"6401e80d","936":"053891aa"}[chunkId] + ".chunk.css";
};